"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Footer;
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
// Import Link from React Router

function Footer() {
  var currentYear = new Date().getFullYear(); // Get the current year
  var copyrightYear = currentYear > 2024 ? "2024-".concat(currentYear) : '2024'; // Determine the year to display

  return /*#__PURE__*/_react["default"].createElement("footer", {
    className: "bg-white"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "mx-auto max-w-7xl px-6 py-12 flex items-center justify-between lg:px-8"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-xs leading-5 text-gray-900"
  }, "\xA9 ", copyrightYear, " Business Daddy Studio, Inc. All rights reserved."), /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-xs leading-5 text-gray-900 flex space-x-4"
  }, /*#__PURE__*/_react["default"].createElement("a", {
    href: "https://businessdaddy.org",
    target: "_blank",
    rel: "noopener noreferrer",
    className: "text-indigo-600 hover:underline"
  }, "Discover more tools at businessdaddy.org"), /*#__PURE__*/_react["default"].createElement("span", {
    className: "text-gray-300"
  }, "|"), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
    to: "/privacy",
    className: "text-indigo-600 hover:underline"
  }, "Privacy"))));
}